export interface UndoModel {
  text: string;
}
